import { Select,FormControl,MenuItem, Card, CardContent   } from '@material-ui/core';
import React,{useState,useEffect} from 'react';
import './App.css';
import InfoBox from './InfoBox';
import LineGraph from './LineGraph';
import Map from './Map';
import Table from './Table'
import { sortData,prettyPrintStat } from './util';
import "leaflet/dist/leaflet.css";




function App() {

const [countries, setCountries] = useState([]);

const [country, setCountry] = useState('worldwide')

const [countryInfo, setCountryInfo] = useState({});

const [tableData, setTableData] = useState([])

const [mapCenter, setMapCenter] = useState({
  lat:18.5204 ,lng:73.8567
});
// 3:25
const [mapZoom, setMapZoom] = useState(3);

const [mapCountries, setMapCountries] = useState([]);

const [casesType, setCasesType] = useState("cases");


useEffect(() => {
  fetch('https://disease.sh/v3/covid-19/all')
  .then(response => response.json())
  .then(data => {
    setCountryInfo(data); 
  })
  
}, [])

  useEffect(() => {
    // The code iside this will loAD once and not again
    //  if you change input it will load
    const getCountriesdata = async() => {
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then((response) => response.json())
      .then((data) => {
        const countries=data.map((country) => (
          {
            name: country.country,
            value: country.countryInfo.iso2

          }
        ));
        const sortedData = sortData(data)
        setTableData(sortedData);
        setMapCountries(data);
        setCountries(countries);
      });
    };
    getCountriesdata();
  }, [])

  const onCountryChange = async (event) =>{
    const countryCode = event.target.value;
    setCountry(countryCode);

    const url = countryCode === 'worldwide' ? 'https://disease.sh/v3/covid-19/all' :
     `https://disease.sh/v3/covid-19/countries/${countryCode}`;

     await fetch(url)
     .then(response=> response.json())
     .then(data => {
        setCountry(countryCode);
        setCountryInfo(data);
        setMapCenter([data.countryInfo.lat, data.countryInfo.long])
        setMapZoom(3);
     })
    // https://disease.sh/v3/covid-19/all
    // https://disease.sh/v3/covid-19/countries/{COUNTRY_CODE}
  }

  console.log("Country Info",countryInfo);
  return (
    <div className="App">
      <div className="app__left">
      <div className="app__header">
      <h1>COVID-19 TRACKER</h1>
      <FormControl className="app__dropdown">
        <Select
          variant="outlined"
          onChange={onCountryChange}
          value={country}
        >

          <MenuItem value="worldwide">WorldWide</MenuItem>
          {
            countries.map(country =>(
              <MenuItem value={country.value}>{country.name}</MenuItem>
            ))
          }
        </Select>
      </FormControl>
      </div>
      
          <div className="app__stats">
            
          <InfoBox
          isRed
          active = {casesType==="cases"}
          onClick={e => setCasesType('cases')} title="Confirmed Cases"
          cases={prettyPrintStat(countryInfo.todayCases)}
          total={prettyPrintStat(countryInfo.cases)}
          />

          <InfoBox
          active = {casesType==="recovered"}
          onClick={e => setCasesType('recovered')} title="Recovered Cases"
          cases={prettyPrintStat(countryInfo.todayRecovered)}
          total={prettyPrintStat(countryInfo.recovered)}
          
          />

          <InfoBox 
          isRed 
          active = {casesType==="deaths"}
          onClick={e => setCasesType('deaths')} title="Deaths"
          cases={prettyPrintStat(countryInfo.todayDeaths)}
          total={prettyPrintStat(countryInfo.deaths)}
          
          />
     
          </div>
          <Map 
          countries = {mapCountries}
          casesType ={casesType}
          center={mapCenter}
          zoom = {mapZoom}
          />
      </div>
      
      <Card className="app__right">
        <CardContent>
          <h3>Live cases by country</h3>
            <Table countries={tableData}/>
          <h3
          className="app_graphTitle"
          >World-wide new {casesType}</h3>
          <LineGraph className='app__graph' 
          casesType={casesType} />

      </CardContent>
      </Card>
      
    </div>
  );
}

export default App;